import Navbar from "./components/Navbar";
import HeroBanner from "./components/HeroBanner";
import TableOfContents from "./components/TableOfContents";
import SecurityLicence from "./components/SecurityLicence";
import Games from "./components/Games";
import SportsBetting from "./components/SportsBetting";
import Bonuses from "./components/Bonuses";
import Payment from "./components/Payment";
import PaymentMethodsGuide from "./components/PaymentMethodsGuide";
import Blog from "./components/Blog";
import MobileGambling from "./components/MobileGambling";
import CustomerSupport from "./components/CustomerSupport";
import Conclusion from "./components/Conclusion";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div
      className="min-h-screen relative"
      style={{
        background: "linear-gradient(160deg, #03112B 0%, #041840 20%, #03112B 50%, #03112B 80%, #020c20 100%)",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* Global background radial glows */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden" style={{ zIndex: 0 }}>
        <div
          className="absolute"
          style={{
            width: "800px", height: "800px",
            top: "10%", left: "50%",
            transform: "translateX(-50%)",
            background: "radial-gradient(circle, rgba(16,92,232,0.08) 0%, transparent 70%)",
            borderRadius: "50%",
          }}
        />
        <div
          className="absolute"
          style={{
            width: "600px", height: "600px",
            top: "60%", left: "10%",
            background: "radial-gradient(circle, rgba(16,92,232,0.06) 0%, transparent 70%)",
            borderRadius: "50%",
          }}
        />
        <div
          className="absolute"
          style={{
            width: "400px", height: "400px",
            top: "40%", right: "5%",
            background: "radial-gradient(circle, rgba(201,168,76,0.04) 0%, transparent 70%)",
            borderRadius: "50%",
          }}
        />
      </div>

      <div className="relative" style={{ zIndex: 1 }}>
        <Navbar />
        <HeroBanner />

        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-4 md:px-8">
          <TableOfContents />

          <div>
            <SecurityLicence />
            <div className="section-divider my-2" />
            <Games />
            <div className="section-divider my-2" />
            <SportsBetting />
            <div className="section-divider my-2" />
            <Bonuses />
            <div className="section-divider my-2" />
            <Payment />
            <div className="section-divider my-2" />
            <PaymentMethodsGuide />
            <div className="section-divider my-2" />
            <Blog />
            <div className="section-divider my-2" />
            <MobileGambling />
            <div className="section-divider my-2" />
            <CustomerSupport />
            <div className="section-divider my-2" />
            <Conclusion />
            <div className="section-divider my-2" />
            <FAQ />
          </div>
        </main>

        <Footer />
      </div>

      {/* Scroll to top */}
      <ScrollToTop />
    </div>
  );
}

function ScrollToTop() {
  const handleClick = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 w-11 h-11 flex items-center justify-center rounded-xl cursor-pointer transition-all duration-200 hover:scale-110 z-40"
      style={{
        background: "linear-gradient(135deg, #105CE8, #0a4bc0)",
        border: "1px solid rgba(16,92,232,0.4)",
        boxShadow: "0 0 20px rgba(16,92,232,0.4)",
      }}
      aria-label="Scroll to top"
    >
      <i className="ri-arrow-up-line text-white text-lg"></i>
    </button>
  );
}
